// extracted by mini-css-extract-plugin
export default {"spa-password":"styles_spa-password__eO4lO","checkbox":"styles_checkbox__XnxCY"};